import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { Stack, Typography } from "@mui/material";
import FeatureTag from "../tags/feature-tag";
import IconTag from "../tags/icon-tag";
import { BottomRight, GridImageCard, NavCardActionArea, TopRight } from "./styled-components";

/**
 * This component is part of the VR app V2 redesign
 */

interface INavCard {
  title: string;
  description?: string;
  tag?: string;
  icon?: IconDefinition;
  disabled?: boolean;
  onClick?: () => void;
}

const NavCard = ({ title, description, tag, icon, disabled, onClick }: INavCard) => {
  return (
    <GridImageCard disabled={disabled}>
      <HapticsButtonWrapper>
        <NavCardActionArea onClick={onClick} disabled={disabled}>
          <Stack
            spacing={1}
            sx={{
              maxWidth: "350px",
            }}
          >
            <Typography variant="text4xl700" color="dsBase.v200">
              {title}
            </Typography>
            <Typography variant="text1xl500" color="dsNeutral.v400">
              {description}
            </Typography>
          </Stack>
          {tag && (
            <TopRight>
              <FeatureTag text={tag} />
            </TopRight>
          )}
          {icon && (
            <BottomRight>
              <IconTag icon={disabled ? faLock : icon} />
            </BottomRight>
          )}
        </NavCardActionArea>
      </HapticsButtonWrapper>
    </GridImageCard>
  );
};

export default NavCard;
